<template>
  <div class="nav-bar van-hairline--top">
    <ul class="nav-list">

      <!--   <router-link tag="li" class="nav-list-item active" :to="{path: '/news/windzxsh',title: '资讯'}">
        <van-icon name="more-o" />
        <span>资讯</span>
      </router-link> -->
      <!-- <router-link tag="li" class="nav-list-item active" :to="{path: '/mini/OnlineMinigames',title: '单机游戏'}">
        <van-icon name="more-o" />
        <span>单机游戏</span>
      </router-link> -->
      <!-- <router-link tag="li" class="nav-list-item" :to="{ name: 'playletLink', title: '在线小游戏' }">
        <van-icon class-prefix="my-icon" name="game" />
        <span>在线小游戏</span>
      </router-link> -->

      <router-link tag="li" class="nav-list-item" to="/">
        <van-icon class-prefix="my-icon" name="game" />
        <span>网游</span>
      </router-link>

      <router-link tag="li" class="nav-list-item" :to="{ name: 'helperLink' }">
        <van-icon name="service-o" />
        <span>{{ $t("LAN.helper") }}</span>
      </router-link>

      <!-- <router-link tag="li" class="nav-list-item" :to="{ name: 'playletLink', title: '短剧' }">
        <van-icon name="video-o" />
        <span>短剧</span>
      </router-link> -->

      <router-link tag="li" class="nav-list-item" :class="$V()" :to="{ name: 'my' }">
        <van-icon name="manager-o" />
        <span>{{ $t("LAN.mine") }}</span>
      </router-link>

      <!-- <router-link tag="li" class="nav-list-item" :to="{path: '/zwsjbx',title:'创收'}">
          <van-icon name="gold-coin-o" />
        <span>创收</span>
      </router-link>  -->

      <!-- <router-link teag="li" v-for="(item, index) in partList" :key="index" class="nav-list-item"
        :to="{ path: item.path, title: item.menuName }">
        <van-icon :name="item.icon" class-prefix="my-icon" v-if="item.icon == 'game'" />
        <van-icon v-else :name="item.icon" />
        <span>{{ langConvert(item) }}</span>
      </router-link> -->

    </ul>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
// import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";

export default {
  setup() {
    // const store = useStore()
    const { t } = useI18n();
    //返回的数据
    const state = reactive({
    });


    //根据配置变量获取多语言
    const langConvert = (item) => {
      if (item.langVariable) {
        return t(item.langVariable);
      }
      return item.menuName;
    }

    //初始化执行
    onMounted(() => {
    });

    return {
      ...toRefs(state),
      langConvert
    }
  }
}
</script>





<style lang="less" scoped>
@import "../style/mixin";

.nav-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 5px 0;
  background: #fff;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  border-top: 1px solid #ebedf0;

  .nav-list {
    width: 100%;
    .fj();
    flex-direction: row;
    padding: 0;

    .nav-list-item {
      display: flex;
      flex: 1;
      flex-direction: column;
      text-align: center;
      color: #666;

      &.router-link-active {
        color: @primary;
      }

      i {
        text-align: center;
        font-size: 22px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}

@media screen and (min-width: 640px) {
  .nav-bar {
    font-size: 100px !important;
    max-width: 640px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
</style>